import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { MessageService } from '../_services/message.service';

import { Tracking } from '../_models/tracking';
import { User } from '../_models/user';
import { Globals } from '../_globals/globals';


@Injectable({
  providedIn: 'root'
})

export class TrackingService {

  constructor(
    private http: HttpClient,
    // private httpParams: HttpParams,
    private globals: Globals,
    private messageService: MessageService
  ) {}

  getTrackings(searchParams): Observable<Tracking[]> {

    console.log('-->--> Ejecutando servicio getTrackings.');
    console.log(searchParams);
    console.log('---------------');

    let params = new HttpParams();

    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        // Para controlar que exista un elemento con esa key.
        if (searchParams.hasOwnProperty(key)) {
          params = params.set(key, searchParams[key]);
        }
      }
    }

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: params };

    return this.http.get<Tracking[]>(this.globals.apiUrl + '/trackings', options)
      .pipe(
        tap( data => console.log(' -> Proyectos obtenidos desde getTrackings: ')), // + JSON.stringify(data))),
        catchError(this.handleError<Tracking[]>('getTrackings', [])
      ));
  }

  getAllTrackings(): Observable<Tracking[]> {

    console.log('-->--> Ejecutando servicio getAllTrackings');

    return this.http.get<Tracking[]>(this.globals.apiUrl + '/trackings')
      .pipe(
        tap( data => console.log(' -> Proyectos obtenidos desde getAllTrackings: ' + JSON.stringify(data))),
        catchError(this.handleError<Tracking[]>('getAllTrackings', [])
      ));
  }

  getTracking(searchParams): Observable<Tracking> {

    console.log('-->--> Ejecutando servicio getTracking');
    console.log(searchParams);
    console.log('---------------');

    // Add safe, URL encoded search parameter if there is a search term
    const options = { params: new HttpParams()
        .set('id', searchParams.id)
    };
    return this.http.get<Tracking>(this.globals.apiUrl + '/tracking', options)
      .pipe(
        tap(  _ => this.log('get tracking')),
        catchError(this.handleError<Tracking>('getTracking', null)
      ));
  }

  updateTracking(trackingIn: Tracking): Observable<Tracking> {

    console.log('-->--> Ejecutando servicio updateTracking');
    console.log(trackingIn);
    console.log('---------------');

    let options = {};
    if (trackingIn.id === null) {
      options = { params: new HttpParams()
        .set('id', '0') };
    } else {
      options = { params: new HttpParams()
        .set('id', trackingIn.id.toString()) };
    }

    return this.http.put<Tracking>(this.globals.apiUrl + '/tracking', trackingIn, options)
      .pipe(
        tap(  _ => this.log('updated tracking')),
        catchError(this.handleError<Tracking>('updateTracking', null)
      ));
  }

  createTracking(trackingIn: Tracking): Observable<Tracking> {

    console.log('-->--> Ejecutando servicio createTracking');
    console.log(trackingIn);
    console.log('---------------');

    let options = {};

    return this.http.post<Tracking>(this.globals.apiUrl + '/tracking', trackingIn, options)
      .pipe(
        tap(  _ => this.log('created tracking')),
        catchError(this.handleError<Tracking>('createTracking', null)
      ));
  } // End function createTracking

  deleteTracking(trackingIn: Tracking): Observable<bigint> {

    console.log('-->--> Ejecutando servicio deleteTracking');
    console.log(trackingIn);
    console.log('---------------');

    let options = { params: new HttpParams()
        .set('id', trackingIn.id.toString()) };

    return this.http.delete<bigint>(this.globals.apiUrl + '/tracking', options)
      .pipe(
        tap(  _ => this.log('deleted tracking')),
        catchError(this.handleError<bigint>('deleteTracking', null)
      ));
  } // End function deleteTracking

  // -------------------------

  // Servicio para obtener los agentes comerciales.
  getUsers(): Observable<User[]> {

    console.log('-->--> Ejecutando servicio getUsers');

    return this.http.get<User[]>(this.globals.apiUrl + '/users')
      .pipe(
        tap( data => console.log(' -> Comerciales obtenidos desde getUsers.')),
        catchError(this.handleError<User[]>('getUsers', [])
      ));
  }

  /** Log a HeroService message with the MessageService */
  private log(message: string) {
    this.messageService.add(`HeroService: ${message}`);
  }

  // -------------------------

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error (error); // lot to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // TODO: Let the app keep running by returning an empty result.
      return of (result as T);
    };
  }

}
